/**
 * Afrikaans (af): every file of this language, combined into the one catalogue the console reads.
 *
 * Standard South African Afrikaans. Address the reader as "jy". Use the same Afrikaans word for the same
 * English term everywhere; menu.ts and common.ts set the words the other files follow. Afrikaans must stay
 * complete: the release checks fail if a key is missing.
 *
 * One file per part of the console; sections.json says which keys go in which file and how each should sound.
 * Add new keys with scripts/i18n/add-keys.mjs, which puts each key in its file.
 */

import type { Catalog } from '../types';
import common from './common';
import menu from './menu';
import signIn from './sign-in';
import dashboard from './dashboard';
import inbox from './inbox';
import contacts from './contacts';
import compose from './compose';
import broadcasts from './broadcasts';
import bookings from './bookings';
import tickets from './tickets';
import templates from './templates';
import flows from './flows';
import knowledge from './knowledge';
import ai from './ai';
import insights from './insights';
import flowIdeas from './flow-ideas';
import numbers from './numbers';
import channels from './channels';
import voice from './voice';
import billing from './billing';
import refer from './refer';
import developers from './developers';
import settings from './settings';
import files from './files';
import guides from './guides';

const afrikaans: Catalog = {
  ...common,
  ...menu,
  ...signIn,
  ...dashboard,
  ...inbox,
  ...contacts,
  ...compose,
  ...broadcasts,
  ...bookings,
  ...tickets,
  ...templates,
  ...flows,
  ...knowledge,
  ...ai,
  ...insights,
  ...flowIdeas,
  ...numbers,
  ...channels,
  ...voice,
  ...billing,
  ...refer,
  ...developers,
  ...settings,
  ...files,
  ...guides
};

export default afrikaans;
